export default {
  table_ordering: 'Tischbestellung',
  table: 'Tisch',
  pickup_or_delivery: 'Abholung oder Lieferung',
  asap: 'So schnell wie möglich',
  served_in: 'Serviert in {{time}} Min.',
  not_taking_orders: 'Keine Bestellungen',
  not_your_table: 'Nicht dein Tisch? Scanne den Code auf deinem.',
  eating_here: {
    title: 'Isst du hier?',
    back_to_table: 'Bestell an {{table}}, wir bringen es dir.',
    scan_code: 'Scanne den QR-Code auf deinem Tisch, um dorthin zu bestellen.',
  },
  notes: {
    table_unavailable: {
      title: 'Der QR-Code dieses Tisches funktioniert nicht mehr.',
      text: 'Bitte frag das Personal. Du kannst trotzdem zur Abholung bestellen.',
      text_no_pickup: 'Bitte frag das Personal.',
    },
    table_ordering_off: {
      title: 'Bestellen am Tisch ist gerade nicht möglich.',
      text: 'Du kannst stattdessen zur Abholung bestellen.',
    },
    load_failed: {
      title: 'Dein Tisch konnte nicht geladen werden.',
      text: 'Bitte scanne den QR-Code noch einmal.',
    },
    closed: {
      title: 'Gerade geschlossen.',
      text: 'Ab {{time}} kannst du am Tisch bestellen.',
      text_later: 'Du kannst am Tisch bestellen, sobald wir wieder geöffnet haben.',
    },
    paused: {
      title: 'Gerade keine Bestellungen möglich.',
      text: 'Bitte frag das Personal oder versuch es in ein paar Minuten noch einmal.',
    },
  },
  cart: {
    closed:
      'Gerade geschlossen. Ab {{time}} kannst du am Tisch bestellen. Dein Warenkorb bleibt bis dahin gespeichert.',
    closed_later: 'Gerade geschlossen. Dein Warenkorb bleibt gespeichert, bis wir wieder geöffnet haben.',
    paused: 'Gerade keine Bestellungen möglich. Dein Warenkorb bleibt gespeichert. Bitte frag das Personal.',
  },
  cash_note: 'Bar an der Theke bezahlen.',
  confirmation: {
    bring_to_table: 'Wir bringen deine Bestellung an deinen Tisch.',
    your_table: 'Dein Tisch',
    moved_table: 'Tisch gewechselt? Nenn dem Personal deine Bestellnummer <strong>{{number}}</strong>.',
  },
  served: 'Serviert',
};
